<template>
  <section class="car-class-list-container">
    <div class="header">
      <div class="filter">
        <div class="statis-tip">
          <span class="inline-block fs-14 color-tip"><span class="fs-24">{{classNum}}</span> Insurer Classes</span>
          <span  class="inline-block"><span class="fs-24">{{makeNum}}</span> Makes</span>
          <span  class="inline-block"><span class="fs-24">{{modelNum}}</span>  Models</span>
        </div>
        <div class="flex">
          <div class="item">
            <span class="item_name">Insurer</span>
            <v-select
              v-model="filter.insurer"
              :list="carClassInsureList"
              @change="filterData"></v-select>
          </div>
          <div class="item">
            <span class="item_name">Make</span>
            <v-select
              v-model="filter.make_id"
              :list="carClassMakeList"
              @change="filterData"></v-select>
          </div>
          <div class="item">
            <span class="item_name">Model</span>
            <v-input
              v-model="filter.model"
              keyNonChinese
              uppercase
              :prefixIcon="'el-icon-search'"
              @change="filterData"></v-input>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <el-table
          :data="formData.list"
          style="width: 100%"
          :header-row-class-name="'tableHeader'"
        >
          <el-table-column
            width="10px"
            fixed
            align="center">
          </el-table-column>

          <el-table-column
            width="200px"
            fixed
            label="Make & Model">
            <template #default="{ row }">
              <div class="flex-column">
                <span>{{ row.make }}</span>
                <span class="mobile"> {{ row.model }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            width="80px"
            label="EV">
            <template #default="{ row }">
              <div class="flex-column">
                <span>{{ row.grade_electric }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            min-width="120px"
            label="Windscreen">
            <template #default="{ row }">
              <div class="flex-column">
                <span> {{ row.grade_wind }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item,index) in company_list"
            :key="'company_list_'+index"
            min-width="150px"
            :label="item.company">
            <!--            <template  slot-scope="scope">-->
            <template slot-scope="scope">
              <div class="flex-column max-width-150">
                <lazy-dom notLoading>
                  <el-form-item
                    :ref="`list.${scope.$index}.class.${index}.grade`"
                    :rules="rules.input"
                    :prop="`list.${scope.$index}.class.${index}.grade`"
                  >
                    <v-select
                      v-model="scope.row.class[index].grade"
                      :list="carClassCompanyList(item.company_id,item.trm_of_cvr)"></v-select>
                  </el-form-item>
                </lazy-dom>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </el-form>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      :page-size="10"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getCarModelClassList,updateCarModelClassList} from '@/api/privateCarList'
import {downloadFile} from '@/utils/download'
import {mapActions, mapState} from 'vuex'
import MixinRules from '@/mixins/rules'

export default {
  name: 'classList',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    classId:{
      type:Number,
      default:11
    }
  },
  data () {
    return {
      filter: {
        insurer:'',
        make_id:'',
        model:''
      },
      pageConfig: {
        currentPage: 1,
        total: 20,
      },
      formData: {
        list:[]
      },
      classNum:0,
      makeNum:0,
      modelNum:0,
    }
  },
  computed:{
    carClassCompanyList(){
      return (company_id,trm_of_cvr)=>{
        let class_company = this.carClassOption.class||{}
        if(trm_of_cvr){
          return class_company[company_id][trm_of_cvr]||[]
        }
        return class_company[company_id][0]||[]
      }
    },
    company_list(){
      let {list=[]} = this.formData||{}
      let company_list = []
      if(list.length>0){
        company_list = list[0].class
      }
      return company_list
    }
  },
  watch:{
  },
  async mounted(){
    await this.updateCarClassOptions()
    this.getList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    ...mapActions('common', ['updateCarClassOptions']),
    handleUpdate(){
      this.$refs['form'].validate((valid,rules) => {
        if(valid){
          this.network().updateCarModelClassList()
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.getList()
    },
    getList(){
      let params = {
        ...this.filter,
        pager: this.pageConfig.currentPage,
      }
      this.network().getCarModelClassList(params)
    },
    network(){
      return {
        getCarModelClassList: async(params) =>{
          this.formData.list = []
          params = {
            ...params,
            class_id: this.classId,
            ...this.filter,
            per_page:10
          }
          const {data} = await getCarModelClassList(params)
          let {insurer_count,make_count,model_count} = data
          this.formData.list = data.data
          this.classNum = insurer_count
          this.makeNum = make_count
          this.modelNum = model_count
          this.pageConfig.total = data.model_count
        },
        updateCarModelClassList: async(params) =>{
          let {list} = this.formData||{}
          params = {
            list,
            class_id:this.classId
          }
          const {data} = await updateCarModelClassList(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }

        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../assets/css/car-class-list';
.max-width-150{
  max-width: 150px;
}
</style>
